<nav class="bg-primary-500 density h-(--nexa-navbar-height) flex items-center padding-responsive">
    <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-4">
                <p-button
                    icon="pi pi-bars"
                    [text]="true"
                    [rounded]="true"
                    (onClick)="toggleDrawer()"
                    styleClass="text-white! hover:bg-white/10! focus:bg-white/10!"
                />
                @if (showSupplierLogo()) {
                    <a href="https://beta80group.it" target="_blank" class="text-white text-2xl font-bold">
                        <img src="assets/beta80-logo-white.svg" [alt]="appName()" class="h-8" />
                    </a>
                }
                <div>
                    @if (brandLogoImage()) {
                        <img [src]="brandLogoImage()" [alt]="brandName()" class="h-8" />
                    } @else {
                        <h1 class="text-white text-2xl font-normal">{{ brandName() }}</h1>
                    }
                </div>
            </div>
            <div class="flex items-center gap-2">
                @if (feedbackAvailable()) {
                    <p-button
                        [text]="true"
                        [rounded]="true"
                        (onClick)="requestFeedback()"
                        styleClass="text-white! hover:bg-white/10! focus:bg-white/10!"
                        [ariaLabel]="'NAVBAR.FEEDBACK' | translate"
                    >
                        <ng-template #icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true" class="size-5">
                                <path d="M240-400h122l200-200q9-9 13.5-20.5T580-643q0-11-5-21.5T562-684l-36-38q-9-9-20-13.5t-23-4.5q-11 0-22.5 4.5T440-722L240-522v122Zm280-243-37-37 37 37ZM300-460v-38l101-101 20 18 18 20-101 101h-38Zm121-121 18 20-38-38 20 18Zm26 181h273v-80H527l-80 80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
                            </svg>
                        </ng-template>
                    </p-button>
                }
                <p-button
                    icon="pi pi-user"
                    [text]="true"
                    [rounded]="true"
                    (onClick)="showLogoutConfirmation()"
                    styleClass="text-white! hover:bg-white/10! focus:bg-white/10!"
                    [attr.aria-label]="'NAVBAR.LOGOUT' | translate"
                />
            </div>
    </div>
</nav>

<p-drawer
    [visible]="drawerVisible()"
    (visibleChange)="drawerVisible.set($event)"
    position="left"
    styleClass="h-[98vh]! top-[50%]! translate-y-[-50%]! navbar-drawer-radius w-[98vw]! max-w-[432px]!"
    [modal]="true"
>
    <ng-template #headless>
        <div class="px-[24px] py-[20px] flex flex-col nexa-squish min-h-full max-h-full overflow-hidden">
            <div class="flex justify-between">
                <p-avatar icon="pi pi-user" class="mr-2" size="xlarge" shape="circle" />
                <p-button
                    icon="pi pi-times"
                    [text]="true"
                    [rounded]="true"
                    severity="secondary"
                    (onClick)="drawerVisible.set(false)"
                />
            </div>
            <div class="flex items-center justify-between">
                <div class="flex flex-col">
                    <p class="text-2xl font-normal">{{ userName() }}</p>
                    <p class="text-sm text-primary-500/85">{{ userRole() }}</p>
                </div>
                <p-button icon="pi pi-sign-out" [outlined]="true" styleClass="h-10 w-8" (onClick)="showLogoutConfirmation()" />
            </div>
            <hr class="border-primary-500/10 border-t-2" />
            <nav>
                <ul class="flex flex-col gap-[7px]">
                    @for (group of groupedNavigationItems(); track group.groupKey; let isLast = $last) {
                        @for (item of group.items; track item.label) {
                            <li class="px-[12px] py-[5px] rounded hover:bg-primary-500/10">
                                <a role="link"
                                   tabindex="0"
                                   (click)="navigateTo(item.route)"
                                   (keydown.enter)="navigateTo(item.route)"
                                   class="text-primary-500/85 font-medium flex items-center justify-between cursor-pointer">
                                    <span>{{ item.label }}</span>
                                    @if (item.badge && item.badge > 0) {
                                        <p-badge [value]="item.badge" severity="danger" />
                                    }
                                </a>
                            </li>
                        }
                        @if (!isLast) {
                            <hr class="border-primary-500/10 border-t-2 my-2" />
                        }
                    }
                </ul>
            </nav>
            <hr class="border-primary-500/10 border-t-2 mt-auto" />
            <div class="flex flex-col gap-1">
                <p class="text-primary-500/85 font-bold">{{ appName() }}</p>
                <div class="flex items-baseline justify-between gap-2">
                    <p class="text-sm text-primary-500/80">{{ 'NAVBAR.VERSION' | translate }} {{ appVersion() }}</p>
                    <p class="text-sm text-primary-500/80">&copy; {{ appYear() }}</p>
                </div>
                @if (showTestBanner()) {
                    <div
                        role="status"
                        class="rounded bg-primary-500 px-3 py-1 text-center text-xs font-bold uppercase tracking-wide text-white"
                    >
                        {{ 'ENVIRONMENT.TEST_BANNER' | translate }}
                    </div>
                }
            </div>
        </div>
    </ng-template>
</p-drawer>

<nexa-dynamic-dialog
    [visible]="showLogoutDialog()"
    [content]="logoutMessage()"
    [config]="logoutDialogConfig()"
    (visibleChange)="showLogoutDialog.set($event)"
    (onClose)="closeLogoutDialog()"
/>
